"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.regionSchema = exports.accountRegionSchema = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const data_1 = require("@citibot/data");
const regionArray = [...data_1.regions];
exports.accountRegionSchema = yup_lib_1.default.string().oneOf(data_1.regions).required().label('Region');
exports.regionSchema = yup_lib_1.default.object().shape({
    region: yup_lib_1.default.string().oneOf(data_1.regions).required()
});
